import { Pipe, PipeTransform } from '@angular/core';
import { Filters } from '../helpers/filters';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {

  public transform(items: any[], field : string): any[] {  
    return Filters.orderAlphabetically(items, field);
  }

}
